import { z } from "zod";
import {
  answerContentSchema,
  answerContentUpdateSchema,
} from "./answerContent";

export const answerSubCategoryDetailSchema = z.object({
    id: z.number(),
    content: z.string(),
    is_answered: z.coerce.boolean(),
    is_submitted: z.coerce.boolean(),
    answer_contents: z.array(answerContentSchema),
});

export const answerSubCategoryWithNavSchema = z.object({
  data: answerSubCategoryDetailSchema,
  prev: z.number().nullable(),
  next: z.number().nullable(),
});

export const answerSubCategoryRequestSchema = z.object({
  answer_contents: z.array(answerContentUpdateSchema),
});

export const answerSubCategoryResponseSchema = z.object({
  data: z.null(),
  message: z.string(),
});

export type AnswerSubCategoryDetail = z.infer<
  typeof answerSubCategoryDetailSchema
>;

export type AnswerSubCategoryWithNav = z.infer<
  typeof answerSubCategoryWithNavSchema
>;

export type AnswerSubCategoryRequestType = z.infer<
  typeof answerSubCategoryRequestSchema
>;
export type AnswerSubCategoryResponseType = z.infer<
  typeof answerSubCategoryResponseSchema
>;